module.exports = __webpack_public_path__ + "static/hcveganjerky-3fd68c08d9d90f4058b0c01ad9308f83.jpg";